import { getTimeSeries } from '../../apiClient';
import { useQuery } from '@tanstack/react-query';

const useGetTimeSeries = (
    { id, resource, type = 'Send', scale = '_1h', start, end },
    enabled
) =>
    useQuery({
        queryKey: [
            `${resource}_timeseries`,
            id,
            type,
            scale,
            `${start}-${end}`,
        ],
        queryFn: async () =>
            getTimeSeries({
                id,
                resource,
                type,
                scale,
                start,
                end,
            }),
        throwOnError: (error) => false,
        refetchOnMount: false,
        retryOnMount: false,
        enabled: enabled,
    });
export default useGetTimeSeries;
